import {Component, Input, OnInit} from '@angular/core';
import {WdrAllgemeinBericht} from "../../../../../../../model/vorhersagen/wdr-wetterbericht";

@Component({
  selector: 'app-wdr-nordrhein-westfalen-bericht',
  templateUrl: './wdr-nordrhein-westfalen-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class WdrNordrheinWestfalenBerichtComponent  {

  @Input()
  nordrheinWestfalenBericht: WdrAllgemeinBericht;


}
